import { c as _c } from "react/compiler-runtime";
import { Badge } from '@common/components';
import { FOCUS_RING } from '@common/components/interaction';
import SvgStarFill from '@common/icon/SvgStarFill';
import { cn } from '@core/utils';
import { CustomLink } from '@/app/_components/CustomLink';
import { Image } from '@/components/client';
import { DONATION_ROUTES } from '@/constants';
import type { WeeklyTopItem } from './weeklyTopItem';
const TOP_HIGHLIGHT_RANK = 3;
interface WeeklyTopRankingItemProps {
  item: WeeklyTopItem;
}
export const WeeklyTopRankingItem = t0 => {
  const $ = _c(47);
  const {
    item
  } = t0;
  let t1;
  if ($[0] !== item.productNumber) {
    t1 = DONATION_ROUTES.GIFTS_DETAIL.pathname({
      productNumber: item.productNumber
    });
    $[0] = item.productNumber;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = cn("group flex items-center gap-12 rounded-small", "mobile-tablet:gap-4", FOCUS_RING);
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = item.rank <= TOP_HIGHLIGHT_RANK ? "text-B-500" : "text-Gray-700";
  let t4;
  if ($[3] !== t3) {
    t4 = cn("w-28 shrink-0 text-center font-700 typo-h5 mobile-tablet:typo-h7", t3);
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== item.rank || $[6] !== t4) {
    t5 = <span className={t4}>{item.rank}</span>;
    $[5] = item.rank;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== item.mainImageUrl || $[9] !== item.productName) {
    t6 = <div className="relative size-80 shrink-0 overflow-hidden rounded-small border border-Gray-100"><Image src={item.mainImageUrl} alt={item.productName} sizes="80px" className="object-cover transition-opacity duration-150 group-hover:opacity-80 group-active:opacity-80 motion-reduce:transition-none" fill={true} /></div>;
    $[8] = item.mainImageUrl;
    $[9] = item.productName;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== item.institutionName) {
    t7 = <p className="truncate font-600 text-Gray-500 typo-caption1">{item.institutionName}</p>;
    $[11] = item.institutionName;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== item.editionBadge) {
    t8 = item.editionBadge ? <Badge dimensions="H20" className="shrink-0 rounded-xxsmall bg-M-400 text-Gray-white">굿즈증정</Badge> : null;
    $[13] = item.editionBadge;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== item.productName) {
    t9 = <span className="truncate font-500 text-Gray-800 typo-body3 mobile-tablet:typo-body4">{item.productName}</span>;
    $[15] = item.productName;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== t8 || $[18] !== t9) {
    t10 = <p className="flex min-w-0 items-center gap-4">{t8}{t9}</p>;
    $[17] = t8;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== item.requiredDonationAmount) {
    t11 = item.requiredDonationAmount.toLocaleString("ko-KR");
    $[20] = item.requiredDonationAmount;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <span className="font-600">원</span>;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] !== t11) {
    t13 = <span className="font-700 text-Gray-900 typo-body2 mobile-tablet:typo-body3">{t11}{t12}</span>;
    $[23] = t11;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  let t14;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <span className="font-600 text-Gray-400 typo-caption1">기부시 증정</span>;
    $[25] = t14;
  } else {
    t14 = $[25];
  }
  let t15;
  if ($[26] !== t13) {
    t15 = <p className="flex items-center gap-4">{t13}{t14}</p>;
    $[26] = t13;
    $[27] = t15;
  } else {
    t15 = $[27];
  }
  let t16;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <SvgStarFill className="size-12 shrink-0 text-Y-550" />;
    $[28] = t16;
  } else {
    t16 = $[28];
  }
  let t17;
  if ($[29] !== item.reviewRating) {
    t17 = item.reviewRating.toFixed(1);
    $[29] = item.reviewRating;
    $[30] = t17;
  } else {
    t17 = $[30];
  }
  let t18;
  if ($[31] !== item.reviewCount) {
    t18 = item.reviewCount.toLocaleString("ko-KR");
    $[31] = item.reviewCount;
    $[32] = t18;
  } else {
    t18 = $[32];
  }
  const t19 = `${t17} (${t18})`;
  let t20;
  if ($[33] !== t19) {
    t20 = <p className="flex items-center gap-4 text-[0.625rem] font-400 leading-[1.6] text-Gray-500">{t16}{t19}</p>;
    $[33] = t19;
    $[34] = t20;
  } else {
    t20 = $[34];
  }
  let t21;
  if ($[35] !== t10 || $[36] !== t15 || $[37] !== t20 || $[38] !== t7) {
    t21 = <div className="flex min-w-0 flex-1 flex-col gap-2">{t7}{t10}{t15}{t20}</div>;
    $[35] = t10;
    $[36] = t15;
    $[37] = t20;
    $[38] = t7;
    $[39] = t21;
  } else {
    t21 = $[39];
  }
  let t22;
  if ($[40] !== t21 || $[41] !== t6) {
    t22 = <div className="flex min-w-0 flex-1 items-center gap-12">{t6}{t21}</div>;
    $[40] = t21;
    $[41] = t6;
    $[42] = t22;
  } else {
    t22 = $[42];
  }
  let t23;
  if ($[43] !== t1 || $[44] !== t22 || $[45] !== t5) {
    t23 = <CustomLink prefetch={false} href={t1} className={t2}>{t5}{t22}</CustomLink>;
    $[43] = t1;
    $[44] = t22;
    $[45] = t5;
    $[46] = t23;
  } else {
    t23 = $[46];
  }
  return t23;
};